export const PAYWAYSERVICES = {
    serviceUrlDev: 'https://paywaywsdev.com/PaywayWS/AccessTokens',
	billingUrlDev: 'https://paywaywsdev.com/PaywayWS/CreditCards',
    serviceUrlProd: 'https://paywayws.com/PaywayWS/AccessTokens',
    billingUrlProd: 'https://paywayws.com/PaywayWS/CreditCards',
}

export const PAYWAY_UI_CONST = {
    appleButton: '#appleButton',
    applePaySubscribeButton: '.apple-pay-btn', //this was in a branch of Robs apple pay stuff, but not in staging so I don't think I need this anymore.
    applePayButton: '.apple-pay-button',
    optionScreen: '#opt__select',
    appleContainer: '#apl__contain',
    appleButtons: '#apl__btns',
    appleRow: '#apple-available',
    paywayTerms: '.terms',
};

export const PAYWAY_MERCHANT_ID = 'merchant.com.payway.mng';
